<style lang="scss">
    @import "../../../sass/layout/tables"
</style>

<template>
    <div class="reports-history mt-5">
        <a id="reports-history"></a>
        <div class="card card-primary p-0">
            <div class="card-header m-0">
                <div class="text-medium-blue m-0">Last 10 Reports</div>
            </div>
            <div class="card-body p-0 table-template">
                <BTable
                    v-if="auth.is('site-admin')"
                    stacked="md" 
                    :fields="fieldsState" 
                    :items="reportsCopy"
                >
                    <template v-slot:cell(type)="data">
                        <strong>
                            <a :href="$basePath+'/reports/' + data.item.id">
                                {{ data.item.type.name }} 
                                <small><span class="fa fa-chevron-right"></span></small>
                            </a>
                        </strong>
                    </template>
                    <template v-slot:cell(created)="data">
                        {{ formatDate(data.item.created_at) }}
                    </template>
                    <template v-slot:cell(programs)="data">
                        {{ (data.item.program) ? data.item.program.name : 'All Programs' }}
                    </template>
                    <template v-slot:cell(range)="data">
                        {{ (data.item.starts_at && data.item.ends_at) ? formatDate(data.item.starts_at) + ' - ' + formatDate(data.item.ends_at) : 'All History' }}
                    </template>
                    <template v-slot:cell(state)="data">
                        {{ (data.item.state_id !== null) ? data.item.state.abbreviation : 'All States' }}
                    </template>
                    <template v-slot:cell(delete)="data">
                        <button type="button" class="btn btn-default bg-white" @click="deleteReport(data.item, data.index)">
                            <span class="fa fa-times"></span>
                        </button>
                    </template>
                </BTable>
                <BTable
                    v-if="auth.is('partner-user')"
                    stacked="md" 
                    :fields="fieldsCounty" 
                    :items="reportsCopy"
                >
                    <template v-slot:cell(type)="data">
                        <strong>
                            <a :href="$basePath+'/reports/' + data.item.id">
                                {{ data.item.type.name }} 
                                <small><span class="fa fa-chevron-right"></span></small>
                            </a>
                        </strong>
                    </template>
                    <template v-slot:cell(created)="data">
                        {{ formatDate(data.item.created_at) }}
                    </template>
                    <template v-slot:cell(programs)="data">
                        {{ (data.item.program) ? data.item.program.name : 'All Programs' }}
                    </template>
                    <template v-slot:cell(range)="data">
                        {{ (data.item.starts_at && data.item.ends_at) ? formatDate(data.item.starts_at) + ' - ' + formatDate(data.item.ends_at) : 'All History' }}
                    </template>
                    <template v-slot:cell(county)="data">
                        {{ (data.item.county_id !== null) ? data.item.county.name : 'All Counties' }}
                    </template>
                    <template v-slot:cell(delete)="data">
                        <a class="delete-report" @click="deleteReport(data.item, data.index)">
                            <span class="fa fa-times"></span>
                        </a>
                    </template>
                </BTable>
                <BTable
                    v-if="!auth.is('site-admin') && !auth.is('partner-user')"
                    stacked="md" 
                    :fields="fieldsNeither" 
                    :items="reportsCopy"
                >
                    <template v-slot:cell(type)="data">
                        <strong>
                            <a :href="$basePath+'/reports/' + data.item.id">
                                {{ data.item.type.name }} 
                                <small><span class="fa fa-chevron-right"></span></small>
                            </a>
                        </strong>
                    </template>
                    <template v-slot:cell(created)="data">
                        {{ formatDate(data.item.created_at) }}
                    </template>
                    <template v-slot:cell(programs)="data">
                        {{ (data.item.program) ? data.item.program.name : 'All Programs' }}
                    </template>
                    <template v-slot:cell(range)="data">
                        {{ (data.item.starts_at && data.item.ends_at) ? formatDate(data.item.starts_at) + ' - ' + formatDate(data.item.ends_at) : 'All History' }}
                    </template>
                    <template v-slot:cell(delete)="data">
                        <a class="delete-report" @click="deleteReport(data.item, data.index)">
                            <span class="fa fa-times"></span>
                        </a>
                    </template>
                </BTable>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        components: {},
        props: {
            reports: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                fieldsCounty: [
                    { key: 'type', label: 'Type of Report'},
                    { key: 'created', label: 'Report Created'},
                    { key: 'programs', label: 'Programs Included'},
                    { key: 'range', label: 'Date Range'},
                    { key: 'county', label: 'County'},
                    { key: 'delete', label: 'Delete'}
                ],
                fieldsState: [
                    { key: 'type', label: 'Type of Report'},
                    { key: 'created', label: 'Report Created'},
                    { key: 'programs', label: 'Programs Included'},
                    { key: 'range', label: 'Date Range'},
                    { key: 'state', label: 'State'},
                    { key: 'delete', label: 'Delete'}
                ],
                fieldsNeither: [
                    { key: 'type', label: 'Type of Report'},
                    { key: 'created', label: 'Report Created'},
                    { key: 'programs', label: 'Programs Included'},
                    { key: 'range', label: 'Date Range'},
                    { key: 'delete', label: 'Delete'}
                ],
                reportsCopy: [],
                auth: window.Auth
            }
        },
        methods: {
            formatDate(date, format = 'MM/DD/YY') {
                return moment(date).format(format);
            },
            deleteReport(report, index) {
                if (confirm('Are you sure you want to delete this report?')) {
                    axios.delete('/reports/'+report.id)
                        .then((response) => {
                            this.reportsCopy.splice(index, 1);
                        })
                        .catch((error) => {
                            alert('there was a problem deleting the report.');
                        })
                }
            }
        },
        computed: {
            $basePath() {
              return window.basePath;
            }
        },
        mounted() {
            this.reportsCopy = JSON.parse(JSON.stringify(this.reports));
        }
    
}
</script>